// extracted by mini-css-extract-plugin
export default {"listContainer":"list_listContainer__X1cvG","background":"list_background__x5rNd","content":"list_content__0MPod","status":"list_status__IGA-x","meta":"list_meta__O6992"};